import React from 'react'
import { Search } from 'lucide-react'
import { Input } from '../../components/ui/input'
import { ClientCard } from './components/ClientCard'
import { useCustomerController } from './useCustomerController'
import { Button } from '../../components/ui/button'
import { Spinner } from '../../components/ui/spinner'

export const Clientes = () => {
  const {
    data,
    handleCustomerDetailsPage,
    handleSearchInputChange,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    ref,
    searchValue,
  } = useCustomerController()

  return (
    <div>
      <h2 className="mb-8 text-2xl font-semibold text-success">
        Gerenciar clientes ({data?.pages[0].pagination.total})
      </h2>
      <div className="mb-8">
        <div className="relative flex items-center">
          <Search size={20} className="z-2 absolute left-4 top-3" />
          <Input
            className="ml-1 w-52 rounded-3xl pl-10 md:w-72"
            placeholder="Pesquisar cliente"
            onChange={handleSearchInputChange}
            value={searchValue}
          />
        </div>
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-customerCards gap-4">
          {data &&
            data.pages.map((page, index) => (
              <React.Fragment key={index}>
                {page.customers.map((customer) => (
                  <ClientCard
                    key={customer._id}
                    _id={customer._id}
                    birthDate={customer.birthDate}
                    name={customer.name}
                    transactions={customer.transactions}
                    value={customer.total}
                    lastTransaction={customer.lastTransaction}
                    handleCustomerDetailsPage={handleCustomerDetailsPage}
                  />
                ))}
              </React.Fragment>
            ))}
        </div>
        <div className="mt-2 flex items-center justify-center" ref={ref}>
          <Button variant="ghost" disabled={!hasNextPage || isFetchingNextPage}>
            {isFetchingNextPage ? <Spinner /> : null}
          </Button>
        </div>
        <div>
          {isFetching && !isFetchingNextPage ? (
            <div className="flex items-center justify-center">
              <Spinner />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
